import React, { useEffect, useState } from "react";
import PublishedMcqType from "../../Published/PublishQuestionType/PublishedMcqType";
import PublishedImgType from "../../Published/PublishQuestionType/PublishedImgType";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "../../../../../axios";
import moment from "moment";
import PrintHomeWorkQs from "../../../../../Homework/pages/On_going/Published/Published_Q_list/PrintHomeWorkQs";
import { timeHelper, dateHelper } from "../../../../../Utils/datetime_helper";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  Paper,
  Typography,
  Chip,
} from "@mui/material";
import {
  ArrowLeft,
  Calendar,
  Clock,
  Edit3,
  FileDown,
  ListChecks,
  Award,
  Zap,
  Sparkles,
} from "lucide-react";

const ACCENT = "#f77f00";
const ACCENT_SOFT = "#fff4e5";
const BORDER = "#e6e9ef";
const TEXT_PRIMARY = "#1f2733";
const TEXT_SECONDARY = "#5b6472";
const BG_SOFT = "#f8f9fb";

const ScheduleQList = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [showUnsavedPrompt, setShowUnsavedPrompt] = useState(false);
  const [pendingNav, setPendingNav] = useState(false);
  const [assessment, setAssessment] = useState();
  const [openDownload, setOpenDownload] = useState();

  useEffect(() => {
    const getAssessment = async () => {
      try {
        let res = await axios.get(
          `/api/v1/assessment/get/${state.assessmentId}`,
        );
        res && setAssessment(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    getAssessment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNavClick = () => {
    const localSaved = localStorage.getItem(
      `EditAssessmentLocalData-${assessment?.id}`,
    );
    console.log("localSaved found");
    if (localSaved) {
      setShowUnsavedPrompt(true);
      setPendingNav(true);
    } else {
      navigate("/EditScheduledQList", {
        state: {
          assessmentId: assessment?.id,
          isAdaptive: assessment.isAdaptive,
          autoEvaluate: assessment?.autoEvalEnabled,
        },
      });
    }
  };

  const backPath =
    localStorage.getItem("Header") === "Content Management"
      ? "/contentMangment"
      : "/publishedAssessment";

  return (
    <>
      {assessment ? (
        <>
          {/* Header Card */}
          <Paper
            elevation={0}
            sx={{
              p: 2,
              mb: 2,
              mt: 1,
              mx: 1,
              borderRadius: "14px",
              border: `1px solid ${BORDER}`,
              background: "linear-gradient(135deg, #fff8f0 0%, #fff5e6 100%)",
            }}
          >
            {/* Breadcrumb */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                mb: 1.25,
                flexWrap: "wrap",
              }}
            >
              <Link
                to={backPath}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  color: ACCENT,
                  textDecoration: "none",
                }}
              >
                <ArrowLeft size={16} />
              </Link>
              <Link to={backPath} style={{ textDecoration: "none" }}>
                <Typography
                  sx={{
                    fontSize: "12.5px",
                    color: TEXT_SECONDARY,
                    fontWeight: 500,
                  }}
                >
                  Assessment
                </Typography>
              </Link>
              <Typography sx={{ fontSize: "12.5px", color: TEXT_SECONDARY }}>
                /
              </Typography>
              <Typography
                sx={{
                  fontSize: "12.5px",
                  color: ACCENT,
                  fontWeight: 700,
                  maxWidth: 420,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                title={assessment?.name}
              >
                {assessment?.name}
              </Typography>
            </Box>

            {/* Title + Action Buttons */}
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 1.5,
              }}
            >
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: TEXT_PRIMARY,
                    letterSpacing: "-0.3px",
                    lineHeight: 1.3,
                  }}
                >
                  {assessment?.name}
                </Typography>

                {/* Chips row */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mt: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Chip
                    icon={<Calendar size={12} color="#fff" />}
                    label="Scheduled"
                    size="small"
                    sx={{
                      background: "#22c55e",
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "11px",
                      "& .MuiChip-icon": { ml: "6px", color: "#fff" },
                    }}
                  />
                  {assessment?.subject_id?.name && (
                    <Chip
                      label={assessment.subject_id.name}
                      size="small"
                      sx={{
                        background: "#fff",
                        color: TEXT_PRIMARY,
                        fontWeight: 600,
                        fontSize: "11.5px",
                        border: `1px solid ${BORDER}`,
                      }}
                    />
                  )}
                  <Chip
                    icon={<ListChecks size={12} color={ACCENT} />}
                    label={`${assessment?.total_questions || 0} Questions`}
                    size="small"
                    sx={{
                      background: ACCENT_SOFT,
                      color: ACCENT,
                      fontWeight: 700,
                      fontSize: "11px",
                      border: `1px solid ${ACCENT}`,
                      "& .MuiChip-icon": { ml: "6px", color: ACCENT },
                    }}
                  />
                  <Chip
                    icon={<Award size={12} color={ACCENT} />}
                    label={`${assessment?.total_marks || 0} Marks`}
                    size="small"
                    sx={{
                      background: ACCENT_SOFT,
                      color: ACCENT,
                      fontWeight: 700,
                      fontSize: "11px",
                      border: `1px solid ${ACCENT}`,
                      "& .MuiChip-icon": { ml: "6px", color: ACCENT },
                    }}
                  />
                  <Chip
                    icon={<Clock size={12} color={ACCENT} />}
                    label={`${assessment?.total_duration || 0} min`}
                    size="small"
                    sx={{
                      background: ACCENT_SOFT,
                      color: ACCENT,
                      fontWeight: 700,
                      fontSize: "11px",
                      border: `1px solid ${ACCENT}`,
                      "& .MuiChip-icon": { ml: "6px", color: ACCENT },
                    }}
                  />

                  {/* Adaptive / Auto-Eval badges */}
                  {state.assessment.isAdaptive && (
                    <Chip
                      icon={<Zap size={12} color="#fff" />}
                      label="Adaptive"
                      size="small"
                      sx={{
                        background: "#7c3aed",
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "11px",
                        "& .MuiChip-icon": { ml: "6px", color: "#fff" },
                      }}
                    />
                  )}
                  {state.assessment.autoEvalEnabled && (
                    <Chip
                      icon={<Sparkles size={12} color="#fff" />}
                      label="Auto-Evaluate"
                      size="small"
                      sx={{
                        background: "#0ea5e9",
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "11px",
                        "& .MuiChip-icon": { ml: "6px", color: "#fff" },
                      }}
                    />
                  )}
                </Box>

                {/* Scheduled on */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mt: 1,
                    fontSize: "12px",
                    color: TEXT_SECONDARY,
                  }}
                >
                  <Calendar size={12} color={TEXT_SECONDARY} />
                  <span>Scheduled on</span>
                  <Typography
                    component="span"
                    sx={{
                      fontSize: "12px",
                      color: ACCENT,
                      fontWeight: 700,
                      ml: 0.5,
                    }}
                  >
                    {dateHelper(assessment?.schedule_date || "")} -{" "}
                    {timeHelper(assessment?.schedule_time || "")}
                  </Typography>
                </Box>
              </Box>

              {/* Action Buttons */}
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Button
                  startIcon={<Edit3 size={15} />}
                  onClick={handleNavClick}
                  variant="contained"
                  sx={{
                    background: ACCENT,
                    color: "#fff",
                    borderRadius: "10px",
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: "13px",
                    px: 2.25,
                    py: 0.85,
                    boxShadow: "0 4px 12px rgba(247,127,0,0.25)",
                    "&:hover": {
                      background: "#e56f00",
                      boxShadow: "0 6px 16px rgba(247,127,0,0.35)",
                    },
                  }}
                >
                  Edit
                </Button>

                <Button
                  startIcon={<FileDown size={15} />}
                  onClick={() =>
                    PrintHomeWorkQs(assessment, false, "Assessment")
                  }
                  variant="outlined"
                  sx={{
                    borderColor: ACCENT,
                    color: ACCENT,
                    borderRadius: "10px",
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: "13px",
                    px: 2.25,
                    py: 0.85,
                    "&:hover": {
                      background: ACCENT_SOFT,
                      borderColor: ACCENT,
                    },
                  }}
                >
                  Export to PDF
                </Button>
              </Box>
            </Box>
          </Paper>

          {/* Questions list */}
          <Box
            className="orange-scrollBar"
            sx={{
              mx: 1,
              pb: 2,
              maxHeight: "calc(100vh - 260px)",
              overflowY: "auto",
            }}
          >
            {assessment?.questions?.length > 0 &&
              assessment?.questions?.map((question, index) => {
                if (
                  question.type.name === "MCQ Type" ||
                  !question.type.is_manually_graded
                ) {
                  return (
                    <PublishedMcqType
                      key={index}
                      questionNumber={index + 1}
                      question={question}
                    />
                  );
                } else {
                  return (
                    <PublishedImgType
                      key={index}
                      questionNumber={index + 1}
                      question={question}
                    />
                  );
                }
              })}
          </Box>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <img
            className="qList_loader"
            src="/gif/LoaderDot.gif"
            alt="Loading"
          />
        </Box>
      )}

      {/* Unsaved changes dialog */}
      <Dialog
        open={showUnsavedPrompt}
        onClose={() => setShowUnsavedPrompt(false)}
        PaperProps={{ sx: { borderRadius: "14px" } }}
      >
        <DialogTitle sx={{ fontWeight: 700, color: TEXT_PRIMARY }}>
          Unsaved Changes Found
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: TEXT_SECONDARY }}>
            You already have unsaved changes for this draft. Do you want to
            restore the unsaved draft?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => setShowUnsavedPrompt(false)}
            variant="outlined"
            sx={{
              borderColor: BORDER,
              color: TEXT_SECONDARY,
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setShowUnsavedPrompt(false);
              navigate("/EditScheduledQList", {
                state: {
                  assessmentId: assessment?.id,
                  isAdaptive: assessment.isAdaptive,
                  autoEvaluate: assessment?.autoEvalEnabled,
                  localData: true,
                },
              });
            }}
            variant="contained"
            sx={{
              background: ACCENT,
              color: "#fff",
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 700,
              "&:hover": { background: "#e56f00" },
            }}
          >
            Continue
          </Button>
          <Button
            onClick={() => {
              localStorage.removeItem(`DraftQAssesmentLocal-${assessment?.id}`);
              setShowUnsavedPrompt(false);
              navigate("/EditScheduledQList", {
                state: {
                  assessmentId: assessment?.id,
                  isAdaptive: assessment.isAdaptive,
                  autoEvaluate: assessment?.autoEvalEnabled,
                },
              });
            }}
            color="error"
            variant="outlined"
            sx={{
              borderColor: "#dc3545",
              color: "#dc3545",
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Ignore
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ScheduleQList;
